// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__NbX0b","section":"Footer_section__5VN0V","link":"Footer_link__MJnZ0","linkTitle":"Footer_linkTitle__ty2KN","linkContent":"Footer_linkContent__SfkTn"};